export const viguideVersion = '2.59.2';
